module.exports = __webpack_public_path__ + "img/reminders-1-mobile.7310de7d.gif";